import { render, staticRenderFns } from "./ProductState.vue?vue&type=template&id=5d44f038&"
import script from "./ProductState.vue?vue&type=script&lang=ts&"
export * from "./ProductState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports